/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Client_Page_CrumbInputs */

const en_booking_client_page_crumb = /** @type {(inputs: Booking_Client_Page_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client`)
};

const pl_booking_client_page_crumb = /** @type {(inputs: Booking_Client_Page_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczny`)
};

/**
* | output |
* | --- |
* | "Client" |
*
* @param {Booking_Client_Page_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_client_page_crumb = /** @type {((inputs?: Booking_Client_Page_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Client_Page_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_client_page_crumb(inputs)
	return en_booking_client_page_crumb(inputs)
});